import './tooltip.css';
export var tooltipAnimationWrapperCSS = '_1nfg8nt2-2-0-1';
export var tooltipElementCSS = '_1nfg8nt1-2-0-1';
export var tooltipOffsetVar = 'var(--_1nfg8nt0-2-0-1)';